import { render, staticRenderFns } from "./addApi.vue?vue&type=template&id=48104f30"
import script from "./addApi.vue?vue&type=script&lang=js"
export * from "./addApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports